// extracted by mini-css-extract-plugin
export var answertext = "CommonQuestion-module--answertext--c12e0";
export var caqsectionbreak = "CommonQuestion-module--caqsectionbreak--b5e10";
export var commonquestion = "CommonQuestion-module--commonquestion--16033";
export var commonquestionnospace = "CommonQuestion-module--commonquestionnospace--c23ec CommonQuestion-module--commonquestion--16033";
export var gradient = "CommonQuestion-module--gradient--e777f";
export var showmore = "CommonQuestion-module--showmore--636c3";
export var title = "CommonQuestion-module--title--367f2";
export var visibilityhidden = "CommonQuestion-module--visibilityhidden--35785";